import { compose } from 'recompose'
import { connect } from 'react-redux'
import toggle from 'components/common/hoc/toggle'
import { formatPhoneNumber } from 'helpers/phone-number'
import { showStoreLocatorModalInAppointmentMode } from 'actions/storeLocator'
import ProductBlock from './ProductBlock'
import withPromoModal from 'components/common/hoc/withPromoModal'

const toggleDefaultValue = true

const mapStateToProps = ({ myStore }) => ({
  myStore,
  storePhoneNumber: myStore ? myStore.phoneNumbers[0] : undefined,
  formattedStorePhoneNumber: myStore ? formatPhoneNumber(myStore.phoneNumbers[0]) : undefined
})

export default compose(
  connect(mapStateToProps, { showStoreLocatorModalInAppointmentMode }),
  toggle,
  withPromoModal
)(ProductBlock, toggleDefaultValue)
